module.exports = __webpack_public_path__ + "img/Beta Digitis - Gif 2_2-208.db5e0b48.png";